"use client";
import { useFormContext, useWatch } from "react-hook-form";
import React from "react";
import { FormCard } from "@/forms/FormCard";
import { CheckoutForm } from "@/checkout/types";
import { AddressFields } from "@/forms/address/AddressFields";
import { AddressType } from "@cappelendamm/e-commerce-services";
import { DeliveryAsBillingCheckbox } from "@/forms/address/DeliveryAsBillingCheckbox";
import { BirthdateFields } from "@/forms/customer/BirthdateFields";
import { FormGroup } from "@/forms/FormGroup";
import { useAuth } from "@clerk/nextjs";
import { getIsTeacherFromSessionClaims } from "@/utils/getIsTeacherFromSessionClaims";

type AddressGroupProps = {
  isDisabled: boolean;
  hideBirthdateFields?: boolean;
};

export const AddressGroup = ({
  isDisabled,
  hideBirthdateFields,
}: AddressGroupProps) => {
  const { sessionClaims } = useAuth();
  const isTeacher = getIsTeacherFromSessionClaims(sessionClaims);
  const { control } = useFormContext<CheckoutForm>();
  const billingAddressIsSameAsDeliveryAddress = useWatch({
    control,
    name: "billingAddressIsSameAsDeliveryAddress",
  });

  return (
    <FormCard>
      <AddressFields
        type={AddressType.DELIVERY}
        title="Leveringsadresse"
        isDisabled={isDisabled}
        hideNameFields={isTeacher}
      />

      {!isTeacher && (
        <FormGroup>
          <DeliveryAsBillingCheckbox isDisabled={isDisabled} />
        </FormGroup>
      )}

      {!billingAddressIsSameAsDeliveryAddress ? (
        <AddressFields
          type={AddressType.BILLING}
          title="Fakturaadresse"
          isDisabled={isDisabled || isTeacher}
          hideNameFields={isTeacher}
        />
      ) : null}

      {!hideBirthdateFields && (
        <BirthdateFields
          isDisabled={isDisabled}
          tooltip={{
            title: "For å bestille med faktura må du være fylt 18 år.",
            expandUpwards: true,
            expandLeftwards: true,
          }}
        />
      )}
    </FormCard>
  );
};
